import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const pincodeList = createAsyncThunk('pincode/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `pincode`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'city_id': data?.city_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const pincodeDetails = createAsyncThunk('pincode/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `pincode/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addPincode = createAsyncThunk('pincode/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'pincode',
            data: {
                "city_id": data?.values?.city,
                "pincode": data?.values?.pincode,
                "delivery_available": data?.values?.delivery_available,
                "cod_available": data?.values?.cod_available,
                "estimated_days": Number(data?.values?.estimated_days),
                "min_order_value": Number(data?.values?.min_order_value),
                "delivery_fee": Number(data?.values?.delivery_fee),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updatePincode = createAsyncThunk('pincode/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'pincode',
            data: {
                "pincode_id": data?.values?.id,
                "city_id": data?.values?.city,
                "pincode": data?.values?.pincode,
                "delivery_available": data?.values?.delivery_available,
                "cod_available": data?.values?.cod_available,
                "estimated_days": Number(data?.values?.estimated_days),
                "min_order_value": Number(data?.values?.min_order_value),
                "delivery_fee": Number(data?.values?.delivery_fee),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delPincode = createAsyncThunk('pincode/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `pincode/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const pincode = createSlice({
    name: 'pincode',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(pincodeList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(pincodeList.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(pincodeList.rejected, (state, action) => {
            state.loading = false;
        });

        builder.addCase(pincodeDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default pincode.reducer;